import type { ReactNode } from "react";
import { Auth0Context } from "@auth0/auth0-react";
import type { Auth0ContextInterface, User } from "@auth0/auth0-react";
import { ROLE_CLAIM, AIRLINE_CODE_CLAIM } from "../constants/auth";

export const mockAuth0User = (overrides: Partial<User> = {}): User => ({
  name: "Dev User",
  email: "dev@booking.com",
  picture: "https://cdn.auth0.com/avatars/du.png",
  sub: "auth0|mock-dev-user",
  email_verified: true,
  [ROLE_CLAIM]: "airline_user",
  [AIRLINE_CODE_CLAIM]: "KE",
  ...overrides,
});

export const mockAuth0Context = (overrides: Partial<Auth0ContextInterface> = {}): Auth0ContextInterface =>
  ({
    isAuthenticated: true,
    isLoading: false,
    user: mockAuth0User(),
    loginWithRedirect: async () => {},
    loginWithPopup: async () => {},
    logout: () => {},
    getAccessTokenSilently: async () => "mock-access-token",
    getAccessTokenWithPopup: async () => "mock-access-token",
    getIdTokenClaims: async () => undefined,
    handleRedirectCallback: async () => ({ appState: {} }),
    ...overrides,
  }) as Auth0ContextInterface;

export const MockAuth0Provider = ({
  children,
  contextOverrides = {},
}: {
  children: ReactNode;
  contextOverrides?: Partial<Auth0ContextInterface>;
}) => <Auth0Context.Provider value={mockAuth0Context(contextOverrides)}>{children}</Auth0Context.Provider>;
